<template>
  <div class="login-view">
    <Login />
  </div>
</template>

<script>
import Login from "@/components/templates/Login";

export default {
  components: { Login },
};
</script>
